// @flow
import PropTypes from 'prop-types'
import { compose, setPropTypes, renameProps } from 'recompose'
import withAuctionCountdown from '../auction/withAuctionCountdown'
import SearchResultsAuctions from '../../ui/views/search-results-auctions'
import withEntity from '../../context/with-entity'

const withPropTypes = setPropTypes({
  entity: PropTypes.object.isRequired,
  entities: PropTypes.arrayOf(PropTypes.number).isRequired
})

const withConversionProps = renameProps({
  entity: 'auction',
  entities: 'auctionsList'
})

const SearchResultsAuctionsEnhancer = compose(
  withEntity,
  withPropTypes,
  withConversionProps,
  withAuctionCountdown
)

export default SearchResultsAuctionsEnhancer(SearchResultsAuctions)



// WEBPACK FOOTER //
// ./src/services/search-results/SearchResultsAuctions.js